import * as actions from '../actions'

var defaultState = null

export default function transaction(state = defaultState, action) {
    switch (action.type) {

        case actions.TRANSACTIONS_GET_ONE:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.TRANSACTIONS_CLEAN_ONE:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/transaction.js